import React from 'react';
import { format } from 'react-string-format';
import Pusher from 'pusher-js';
import {withRouter} from "../withRouter";
import {Button, Modal} from "react-bootstrap";

class ManageGameSecurity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSSModal: false
        };
    }

    handleSubmit(e) {
        e.preventDefault();

        const body = {
            'has_ads': e.target.has_ads.checked,
            'ads_providers': e.target.ads_providers.value.split(','),
            'privacy_policy_url': e.target.privacy_policy_url.value,
            'minimum_age': e.target.minimum_age.value,
            'sensitive_content': e.target.sensitive_content.value.split(',')
        };

        fetch(format(process.env.REACT_APP_API_URL + '/publisher/game/{0}/update/security', this.props.game.id.toString()), {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then((response) => {
            console.log(response);
            console.log(JSON.stringify(body));
            window.location.reload(false);
        });
    }

    handleSSModalClose() {
        this.setState({
            showSSModal:false
        })
    }

    handleSSModalShow() {
        this.setState({
            showSSModal: true,
        })
    }

    render() {
        return (
            <div>
                <h1>App data security</h1>
                <form onSubmit={this.handleSubmit.bind(this)}>
                    <input className="form-check-input" id="has_ads" type="checkbox" name="has_ads" defaultChecked={this.props.game.game_security ? this.props.game.game_security.has_ads : false}/>
                    <label className="form-check-label" htmlFor="has_ads">Has ads</label>

                    <br/>
                    <br/>

                    <label>Ads providers: </label>
                    <input required class="form-control" type="text" name="ads_providers" defaultValue={this.props.game.game_security ? this.props.game.game_security.ads_providers : ''}/>
                    <small id="tags-help" className="form-text text-muted">Separate providers by comma</small>

                    <br/><br/>
                    <label>Privacy policy url: </label>
                    <input required class="form-control" type="url" name="privacy_policy_url" defaultValue={this.props.game.game_security ? this.props.game.game_security.privacy_policy_url : ''}/>
                    <br/>
                    <label>Minimum customer age: </label>
                    <input class="form-control" type="number" name="minimum_age" defaultValue={this.props.game.game_security ? this.props.game.game_security.minimum_age : 18}/>
                    <br/>
                    <label>Sensitive content description: </label>
                    <input required class="form-control" type="text" name="sensitive_content" defaultValue={this.props.game.game_security ? this.props.game.game_security.sensitive_content : ''}/>
                    <small id="tags-help" className="form-text text-muted" onClick={this.handleSSModalShow.bind(this)}>Example</small>
                    <Modal show={this.state.showSSModal} onHide={this.handleSSModalClose.bind(this)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Sensitive content description example</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <input readOnly className="form-control" type="text" value={
                                "Weapon:rarely, adult content:rarely"
                            }/>
                            <br/>
                            <div class="alert alert-danger">
                                Format is the next: <strong>type:frequency</strong>
                                <br/>Split different types by comma.<br/>
                                Remember that this data will be reviewed by moderator and game won't be approved if something is wrong
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.handleSSModalClose.bind(this)}>
                                Ok
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <br/><br/>

                    <input class="btn btn-success" type="submit" value="Save"/>
                </form>
            </div>
        );
    }
}

export default withRouter(ManageGameSecurity);
